import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

import AppLayout from '../layout/AppLayout';
import AgentDashboardPage from '../features/dashboard/AgentDashboardPage';
import InsuredDashboardPage from '../features/dashboard/InsuredDashboardPage';
import LoginPage from '../features/auth/LoginPage';
import BridgePage from '../features/auth/BridgePage';
import CertificatesPage from '../features/certificates/CertificatesPage';
import PoliciesPage from '../features/policies/PoliciesPage';
import AddNewPolicyPage from '../features/policies/AddNewPolicyPage';
import LogsPage from '../features/logs/LogsPage';
import ReportsPage from '../features/reports/ReportsPage';
import ActivityReportPage from '../features/reports/ActivityReportPage';
import NotFoundPage from '../features/errors/NotFoundPage';
import SendCertificatePage from '../features/send-certificate/SendCertificatePage';
import MasterCertificatePage from '../features/master-certificate/MasterCertificatePage';
import CertificateHoldersPage from '../features/certificate-holders/CertificateHoldersPage';
import EmailTemplatesPage from '../features/email-templates/EmailTemplatesPage';
import SelectClientPage from '../pages/SelectClientPage';
import { Navigate } from 'react-router-dom';
import SignaturePage from 'features/Signature/SignaturePage';
import EmailCheckPage from '../features/email-check/EmailCheckPage';
import EmailExchangeCallbackPage from '../features/email-check/EmailExchangeCallbackPage';
import ProtectedRoute from '../components/ProtectedRoute';

export default function AppRoutes() {
  const { hasReportsAccess } = useAuth();
  return (
    <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/bridge" element={<BridgePage />} />
        <Route path="/selectclient" element={<SelectClientPage />} />
        <Route path="/emailexchange" element={<EmailExchangeCallbackPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AppLayout />}>
            <Route path="/dashboard" element={<AgentDashboardPage />} />
            <Route path="/agentdashboard" element={<AgentDashboardPage />} />
            <Route path="/insureddashboard" element={<InsuredDashboardPage />} />
            <Route path="/sendcertificate" element={<SendCertificatePage />} />
            <Route path="/mastercertificate" element={<MasterCertificatePage />} />
            <Route path="/certificateholders" element={<CertificateHoldersPage />} />
            <Route path="/certificates/*" element={<CertificatesPage />} />
            <Route path="/policies/*" element={<PoliciesPage />} />
            <Route path="/addpolicy" element={<AddNewPolicyPage />} />
            <Route path="/logs/*" element={<LogsPage />} />
            <Route path="/reports" element={hasReportsAccess ? <ReportsPage /> : <Navigate to="/agentdashboard" replace />} />
            <Route path="/reports/activity" element={hasReportsAccess ? <ActivityReportPage /> : <Navigate to="/agentdashboard" replace />} />
            <Route path="/email-templates" element={<EmailTemplatesPage />} />
            <Route path="/signature" element={<SignaturePage />} />
            <Route path="/email-check" element={<EmailCheckPage />} />
          </Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
